import React, { useContext, useMemo } from "react";
import Barcode from "react-barcode";
import "../../CSS/Invoice.css";
import AuthUser from "../AuthUser";
import moment from "moment";
import { cashierLang } from "../language/pages/cashierPageLang";
import useLanguage from "../language/useLanguage";
import { appContext } from "../../navbar/auth";

const getItemImageUrl = (item, baseImageUrl) => {
  const drug = item?.drug != null ? item.drug : item;
  let imageFileName = drug?.main_image || drug?.image || item?.main_image || item?.image || "";
  if (!imageFileName || imageFileName === "null" || imageFileName === "undefined" || String(imageFileName).trim() === "") {
    return null;
  }
  imageFileName = String(imageFileName).replace(/^.*[\\/]/, "").split("?")[0].split("#")[0].trim();
  if (!imageFileName) return null;
  const base = baseImageUrl || "";
  const path = base.endsWith("/public") ? base.replace(/\/public\/?$/, "") : base;
  return `${path}/files/drugs/${imageFileName}`;
};

const Invoice = ({
  specialDiscount,
  invoice,
  delivery_charge,
  grandTotal,
  paidAmount,
  selectedInvoice,
  invoiceData,
}) => {
  const { user } = AuthUser();
  const { allSubTotalWithoutDiscount, stickerCart } = useContext(appContext);
  const lan = useLanguage(cashierLang);

  const baseImageUrl = useMemo(() => {
    const fromGlobal = typeof global !== "undefined" && (global.img_url || global.img_Url);
    if (fromGlobal) {
      return String(fromGlobal).replace(/\/public\/?$/, "");
    }
    const url = process.env.REACT_APP_DEV_MODE_IMAGE_URL ||
      process.env.REACT_APP_IMAGE_URL ||
      process.env.REACT_APP_PRO_MODE_IMAGE_URL ||
      "http://127.0.0.1:8001";
    return url.replace(/\/$/, "");
  }, []);

  console.log(invoiceData, "cart");
  const isViewingSelectedInvoice = Boolean(selectedInvoice?.id);
  const effectiveDeliveryCharge = isViewingSelectedInvoice
    ? selectedInvoice?.delivery_charge
    : delivery_charge;
  const effectiveSpecialDiscount = isViewingSelectedInvoice
    ? selectedInvoice?.special_discount
    : specialDiscount;
  const effectivePaidAmount = isViewingSelectedInvoice
    ? selectedInvoice?.paid_amount
    : paidAmount;
  const effectiveGrandTotal = isViewingSelectedInvoice
    ? selectedInvoice?.grand_total ??
      (parseFloat(selectedInvoice?.sub_total || 0) -
        parseFloat(selectedInvoice?.special_discount || 0))
    : grandTotal ?? (parseFloat(allSubTotalWithoutDiscount || 0) - parseFloat(specialDiscount || 0));
  const effectiveLastDueDate = isViewingSelectedInvoice
    ? selectedInvoice?.last_due_date
    : invoiceData?.last_due_date;
  const effectiveLastDue = isViewingSelectedInvoice
    ? selectedInvoice?.last_due
    : invoiceData?.last_due;
  const effectivePresentDue = isViewingSelectedInvoice
    ? selectedInvoice?.present_due ?? selectedInvoice?.due_amount
    : null;
  return (
    <div
      style={{ paddingLeft: "35px", paddingRight: "35px" }}
      className="invoice-print"
    >
      <div className="invoice-pharmacy-details d-flex align-items-center">
        <img
          src={user?.organization?.logo}
          className="img-fluid"
          style={{ height: "80px" }}
          alt=""
        />
        <div className="text-center flex-grow-1">
          <div style={{ marginLeft: "-80px" }}>
            <h5>{user?.organization?.name}</h5>
            <p>Location : {user?.organization?.address}</p>
            <p>Tel : {user?.organization?.mobile}</p>
            <h6 className="mt-2">{lan?.invoice}</h6>
          </div>
        </div>
      </div>

      <div className="invoice-date invoice-border-dashed">
        {/* <p style={{textAlign:'center'}}>Invoice No : {invoice} </p>
                <p style={{textAlign:'center'}}>Sales Person : Dummy </p> */}

        <div className="d-flex justify-content-between">
          <div>
            <p>
              {lan?.name} : {invoiceData?.name}{" "}
            </p>
            <p>
              {lan?.address} : {invoiceData?.address}{" "}
            </p>
            <p>
              {lan?.mobile} : {invoiceData?.mobile}{" "}
            </p>
          </div>
          <div>
            <p style={{ textAlign: "end" }}>
              {lan?.invoiceNo} : {invoice}{" "}
            </p>
            <p style={{ textAlign: "end" }}>
              {lan?.invoice} {lan?.date} :{" "}
              {moment(invoiceData?.date).format("DD-MM-YYYY")}{" "}
            </p>
            <p style={{ textAlign: "end" }}>
              {lan?.printDateTime} : {moment().format("DD-MM-YYYY hh:mm A")}{" "}
            </p>
          </div>
        </div>
      </div>
      <div className="invoice-item-table">
        <table>
          <tr className="invoice-border-dashed">
            <td width={"8%"} className="text-center">Image</td>
            <td width={"32%"}>{lan?.item}</td>
            <td width={"12%"} className="text-right">{lan?.channelName ?? "MRP Channel"}</td>
            <td width={"10%"} className="text-right">
              {lan?.quantity}
            </td>
            <td width={"10%"} className="text-right">
              {lan?.unit}
            </td>
            <td width={"10%"} className="text-right">
              {lan?.price}
            </td>
            <td width={"18%"} className="text-end">
              {lan?.totalPrice}
            </td>
          </tr>
          {stickerCart
            .filter((c) => parseInt(c.pcs) > 0)
            .map((item, i) => {
              const imageUrl = getItemImageUrl(item, baseImageUrl);
              const itemName = item.macrohealth_sg || item.name || item?.drug?.macrohealth_sg || "";
              const itemUnit = item.unit ?? item?.drug?.unit ?? "";
              const mrpChannel = item.mrp_channel_name ?? item.selectedChannelName ?? item.mrpChannelName ?? "";
              return (
                <tr key={i}>
                  <td width={"8%"} className="text-center align-middle">
                    {imageUrl ? (
                      <img
                        src={imageUrl}
                        alt=""
                        style={{ width: "36px", height: "36px", objectFit: "cover", borderRadius: "4px", display: "block", margin: "0 auto" }}
                        onError={(e) => { e.target.style.display = "none"; }}
                      />
                    ) : (
                      <span style={{ fontSize: "18px" }}>📦</span>
                    )}
                  </td>
                  <td width={"32%"}>{itemName}</td>
                  <td width={"12%"} className="text-start">{mrpChannel || "—"}</td>
                  <td width={"10%"} className="text-start">
                    {item?.pcs}
                  </td>
                  <td width={"10%"} className="text-start">
                    {itemUnit}
                  </td>
                  <td width={"10%"} className="text-start">
                    {item?.price}
                  </td>
                  <td width={"18%"} className="text-end">
                    {Number(item.totalPrice)?.toFixed(2)}
                  </td>
                </tr>
              );
            })}
          <tr className="invoice-border-dashed-top">
            <td colSpan={6} className="text-end fw-bolder">
              {lan?.subTotal} :{" "}
            </td>
            <td className="text-end">
              {(
                parseFloat(allSubTotalWithoutDiscount) -
                parseFloat(effectiveDeliveryCharge || 0)
              )?.toFixed(2)}{" "}
            </td>
          </tr>

          {/* <tr>
            <td colSpan={4} className="text-end">
              {lan?.vatTax} :{" "}
            </td>
            <td className="text-end">0</td>
          </tr> */}
          <tr>
            <td colSpan={6} className="text-end">
              Delivery Charge :{" "}
            </td>
            <td className="text-end">
              {parseFloat(effectiveDeliveryCharge || 0)?.toFixed(2)}
            </td>
          </tr>
          {(user.user_type === "cashier" ||
            user.user_type === "admin" ||
            user.user_type === "manager") && (
            <tr>
              <td colSpan={6} className="text-end">
                {lan?.specialDiscount} :{" "}
              </td>
              <td className="text-end">
                {parseFloat(effectiveSpecialDiscount || 0).toFixed(2)}
              </td>
            </tr>
          )}

          <tr className="invoice-border-dashed-top">
            <td colSpan={6} className="text-end fw-bolder">
              {lan?.grandTotal} :{" "}
            </td>

            <td className="text-end">
              {parseFloat(effectiveGrandTotal || 0).toFixed(2)}{" "}
            </td>
          </tr>
          <tr className="invoice-border-dashed-top mt-3">
            <td colSpan={5} className="text-end fw-bolder">
              Last Due :{" "}
            </td>
            <td>
              {effectiveLastDueDate
                ? moment(effectiveLastDueDate).format("DD/MM/YYYY")
                : ""}
            </td>
            <td className="text-end">
              {parseFloat(effectiveLastDue || 0).toFixed(2)}
            </td>
          </tr>
          <tr className="invoice-border-dashed-top mt-3"></tr>
          {(user.user_type === "cashier" ||
            user.user_type === "admin" ||
            user.user_type === "manager") && (
            <tr>
              <td colSpan={6} className="text-end fw-bolder">
                {lan?.paidAmount} :{" "}
              </td>
              <td className="text-end">
                {parseFloat(effectivePaidAmount || 0).toFixed(2)}
              </td>
            </tr>
          )}

          {(user.user_type === "cashier" ||
            user.user_type === "admin" ||
            user.user_type === "manager") && (
            <tr className="invoice-border-dashed">
              <td colSpan={6} className="text-end fw-bolder">
                Present Due :{" "}
              </td>

              <td className="text-end">
                {effectivePresentDue != null
                  ? parseFloat(effectivePresentDue || 0).toFixed(2)
                  : parseFloat(
                      (parseFloat(invoiceData?.due || 0) +
                        parseFloat(allSubTotalWithoutDiscount || 0) -
                        parseFloat(effectivePaidAmount || 0) -
                        parseFloat(effectiveSpecialDiscount || 0)) ||
                        0
                    ).toFixed(2)}
              </td>
            </tr>
          )}
        </table>
      </div>
      <div className=" invoice-creator mt-1">
        <p>
          {lan?.providedBy}: {user?.name}
        </p>
      </div>
      {/* <div className="branding-section mt-3 mx-auto text-center mx-auto">
        <p>{lan?.technologyPartner} Zaimah Technologies Ltd.</p>
      </div>

      <div className="invoice-greeting d-flex justify-content-center align-items-center mt-1">
        <Barcode displayValue={false} height={40} width={3} value={invoice} />
      </div> */}
      <div className="d-flex justify-content-center branding-section mt-5">
        <p>{lan?.thankYou}</p>
      </div>
    </div>
  );
};

export default Invoice;
